<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-input hide-details>
          <v-select :items="emailTemplateOptions"
                    :label="$t('admin_hkiarace.email_template')"
                    @change="onEditingEmailTemplateChanged"
                    v-model="editingTemplateId">
            <template #append-outer>
              <v-tooltip top>
                <template #activator="{on, attrs}">
                  <v-btn icon
                         v-on="on"
                         v-bind="attrs"
                         @click="createEmailTemplate">
                    <v-icon>fas fa-plus</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('admin_notification_template.new_template') }}</span>
              </v-tooltip>
            </template>
          </v-select>
        </v-input>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field :label="$t('admin_notification_template.name')"
                      v-model="editingTemplate.name"></v-text-field>
      </v-col>
    </v-row>
<!--    <v-row>-->
<!--      <v-col>-->
<!--        <v-checkbox :label="$t('admin_notification_template.email_enabled')"-->
<!--                    v-model="editingTemplate.email_enabled"></v-checkbox>-->
<!--      </v-col>-->
<!--    </v-row>-->
    <v-row>
      <v-col>
        <v-text-field :label="$t('admin_notification_template.email_subject')"
                      v-model="editingTemplate.email_subject"></v-text-field>
      </v-col>
    </v-row>
    <v-row class="pt-0">
      <v-col>
        <v-input hide-details>
          <v-container fluid class="flex-column">
            <legend class="v-label theme--light">{{ $t('admin_notification_template.email_content') }}</legend>
            <TinyMceEditor v-model="editingTemplate.email_content"></TinyMceEditor>
          </v-container>
        </v-input>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-checkbox :label="$t('admin_notification_template.push_notification_enabled')"
                    v-model="editingTemplate.push_notification_enabled">
        </v-checkbox>
      </v-col>
    </v-row>
    <v-row v-if="editingTemplate.push_notification_enabled">
      <v-col>
        <v-text-field outlined
                      :rules="requiredRules"
                      :label="$t('admin_notification_template.push_notification_content')"
                      v-model="editingTemplate.push_notification_content"></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field outlined
                      :label="$t('admin_notification_template.test_email')"
                      :placeholder="$t('admin_notification_template.recipient')"
                      v-model="testEmailRecipient">
          <template #append-outer>
            <v-tooltip top>
              <template #activator="{on, attrs}">
                <v-btn icon
                       v-on="on"
                       v-bind="attrs"
                       @click="sendTestEmail"
                       :disabled="!testEmailRecipient">
                  <v-icon>fas fa-paper-plane</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('admin_notification_template.send_email') }}</span>
            </v-tooltip>
          </template>
        </v-text-field>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {computed, onMounted, ref, watch} from "@vue/composition-api";
import _ from "lodash";
import TinyMceEditor from "@/components/TinyMceEditor";

export default {
  name: 'EventEmailTemplate',
  components: {TinyMceEditor},
  props: {
    eventId: String,
    canRemove: Boolean,
    remove: Function,
    changed: Boolean,
    save: Function,
  },
  setup(props, {root, emit}) {
    onMounted(() => {
      getEmailTemplates();

      emit('update:remove', deleteEmailTemplate);
      emit('update:save', saveEmailTemplate);
    })

    const requiredRules = ref([
      value => !!value || root.$t('register.required_fields'),
    ]);

    const emailTemplates = ref([]);
    const emailTemplateOptions = computed(() => {
      return emailTemplates.value.map((t) => {
        return {value: t.id, text: t.name}
      });
    })
    const getEmailTemplates = function () {
      root.$callAPI('event/email_template/', {
        event_id: props.eventId,
      }, function (response) {
        emailTemplates.value = response.body.templates;
      });
    }

    const editingTemplateId = ref(null);
    watch(() => editingTemplateId.value, (newValue) => {
      emit('update:canRemove', Boolean(newValue));
    }, {immediate: true});

    const onEditingEmailTemplateChanged = function (template_id) {
      editingTemplate.value = {..._.find(emailTemplates.value, {id: template_id})};
      originalTemplate.value = {...editingTemplate.value};
    }
    const editingTemplate = ref({});
    const originalTemplate = ref(null);
    const createEmailTemplate = function () {
      editingTemplateId.value = null;
      editingTemplate.value = {
        event_id: props.eventId,
        name: '',
        email_enabled: true,
        email_subject: '',
        email_content: '',
        push_notification_enabled: false,
        push_notification_content: '',
      };

      originalTemplate.value = {...editingTemplate.value};
    };
    const templateChanged = computed(() => {
      return !_.isEqual(editingTemplate.value, originalTemplate.value);
    });
    watch(() => templateChanged.value, (newValue) => {
      emit('update:changed', newValue);
    })
    const testEmailRecipient = ref(null);
    const sendTestEmail = function () {
      root.$callAPI('event/email_template/test/', {
        subject: editingTemplate.value.email_subject,
        content: editingTemplate.value.email_content,
        recipient: testEmailRecipient.value,
      }, () => {
        root.$showAlertMessage('Email Sent');
      })
    };
    const deleteEmailTemplate = function () {
      if (confirm('Delete Email Template?')) {
        root.$callAPI('hkiarace/admin/event/email_template/delete/', {
          template_id: editingTemplate.value.id,
          event_id: props.eventId,
        }, () => {
          createEmailTemplate();
          getEmailTemplates();
        })
      }
    };
    const saveEmailTemplate = function () {
      if (templateChanged.value) {
        root.$callAPI('hkiarace/admin/event/email_template/set/', {
          ...editingTemplate.value,
          template_id: editingTemplate.value.id,
          event_id: props.eventId,
        }, (response) => {
          root.$showAlertMessage('Template Saved');
          editingTemplateId.value = response.body.template_id;
          getEmailTemplates();
        })
      }
    };

    return {
      requiredRules,
      emailTemplateOptions,
      editingTemplateId,
      editingTemplate,
      onEditingEmailTemplateChanged,
      createEmailTemplate,
      templateChanged,
      testEmailRecipient,
      sendTestEmail,
      deleteEmailTemplate,
      saveEmailTemplate,
    }
  },
}
</script>
